// src/components/js/LogViewer.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from './side/Sidebar';
import TopHeader from './side/TopHeader';
import Pagination from './side/Pagination';
import SearchBox from './side/SearchBox';
import '../css/LogViewer.css';
import { SERVER_URL } from '../../config/config';

const LogViewer = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [userType, setUserType] = useState('all');
  const [logLevel, setLogLevel] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const logsPerPage = 5;

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        setLoading(true);
        const admin_id = localStorage.getItem('admin_id');
        const response = await axios.get(`${SERVER_URL}/admin/logs?admin_id=${admin_id}`);

        if (response.data.result_code === 201) {
          setLogs(response.data.logs);
          setFilteredLogs(response.data.logs);
        } else {
          setError('로그 데이터를 불러오지 못했습니다.');
        }
      } catch (err) {
        setError('서버 오류: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);

  useEffect(() => {
    filterLogs();
    setCurrentPage(1);
  }, [searchTerm, userType, logLevel, logs]);

  const filterLogs = () => {
    let filtered = [...logs];

    if (searchTerm) {
      filtered = filtered.filter(log => 
        log.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.message.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (userType !== 'all') {
      filtered = filtered.filter(log => 
        (userType === 'admin' && log.is_admin) || 
        (userType === 'user' && !log.is_admin)
      );
    }

    if (logLevel !== 'all') {
      filtered = filtered.filter(log => log.log_level === logLevel);
    }

    setFilteredLogs(filtered);
  };

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog);
  const totalPages = Math.ceil(filteredLogs.length / logsPerPage);

  if (loading) {
    return (
      <div className="user-management">
        <div className="content-wrapper">
          <Sidebar />
          <div className="main-content">
            <div className="loading">로딩 중...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="header-section">
            <h1>로그 확인</h1>
            <div className="log-filters">
              <SearchBox
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="이름 또는 메세지 내용을 입력하세요..."
                onSearch={filterLogs}
              />
              <div className="filter-group">
                <select 
                  value={userType} 
                  onChange={(e) => setUserType(e.target.value)}
                  className="filter-select"
                >
                  <option value="all">전체</option>
                  <option value="admin">관리자</option>
                  <option value="user">유저</option>
                </select>

                <select 
                  value={logLevel} 
                  onChange={(e) => setLogLevel(e.target.value)}
                  className="filter-select"
                >
                  <option value="all">전체 레벨</option>
                  <option value="INFO">INFO</option>
                  <option value="WARN">WARN</option>
                  <option value="ERROR">ERROR</option>
                  <option value="DEBUG">DEBUG</option>
                </select>
              </div>
            </div>
          </div>

          <div className="table-container">
            <div className="header-row" id="log-viewer" style={{ display: 'grid', gridTemplateColumns: '20% 10% 10% 40% 10%' }}>
              <span>TIME</span>
              <span>이름</span>
              <span>로그 레벨</span>
              <span>Message</span>
              <span>구분</span>
            </div>
            <div className="data-entries">
              {error ? (
                <div className="table-row" style={{ display: 'grid', gridTemplateColumns: '20% 10% 10% 40% 10%' }}>
                  <span className="cell" style={{ gridColumn: '1 / -1', color: '#FF4B4B' }}>
                    {error}
                  </span>
                </div>
              ) : currentLogs.length === 0 ? (
                <div className="table-row" style={{ display: 'grid', gridTemplateColumns: '20% 10% 10% 40% 10%' }}>
                  <span className="cell" style={{ gridColumn: '1 / -1', color: '#666' }}>
                    검색된 로그가 없습니다.
                  </span>
                </div>
              ) : (
                currentLogs.map((log, idx) => (
                  <div key={idx} className="table-row" id="log-viewer" style={{ display: 'grid', gridTemplateColumns: '20% 10% 10% 40% 10%' }}>
                    <span className="cell">{log.log_time.replace('T', ' ').slice(0, 19)}</span>
                    <span className="cell">{log.username}</span>
                    <span className={`cell log-level ${log.log_level.toLowerCase()}s`}>
                      {log.log_level}
                    </span>
                    <span className="cell" style={{ justifyContent: 'left' , marginRight: '10px' }}>{log.message}</span>
                    <span className="cell">{log.is_admin ? '관리자' : '유저'}</span>
                  </div>
                ))
              )}
            </div>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default LogViewer;